import type { ComponentProps } from "react";

import { Tag } from "antd";

import type { TableToolbarExtra } from "@neu/libui";

import { PatientStatusCounts } from "./PatientStatusCounts";

export function patientListStatusTagColor(
	value: string
): NonNullable<ComponentProps<typeof Tag>["color"]> {
	switch (value) {
		case "On-Service":
			return "success";
		case "Pending":
		case "On-Hold":
			return "warning";
		case "Inactive":
		case "Account Terminated":
			return "error";
		default:
			return "default";
	}
}

/**
 * Table options for the default patient shell list (`TabListView` via `createAppRouter`).
 * Spread onto the patient entry in `nestedModules`.
 */
export const patientNestedModuleListConfig: {
	entityColOverride: Record<string, unknown>;
	toolbarExtra: TableToolbarExtra;
} = {
	entityColOverride: {
		status: {
			render: (value: string) => (
				<Tag color={patientListStatusTagColor(value)}>{value}</Tag>
			),
		},
	},
	toolbarExtra: ({ filters, onFilterChange }) => (
		<PatientStatusCounts
			filters={filters}
			onFilterChange={onFilterChange}
		/>
	),
};
